import React, { forwardRef } from 'react';

import { Box, Typography, useTheme } from '@mui/material';

import { formatDateForView } from '@shared/utils/formatDateForView';
import { InputError } from 'shared/ui-kit';

type DatePickerInputProps = {
  isDisabled?: boolean;
  isClearable?: boolean;
  dateFormat?: string;
  isLate?: boolean;
  placeholder?: string;
  value?: any;
  [x: string]: any;
};

const DatePickerIconButtonVariant = forwardRef<HTMLHeadingElement, DatePickerInputProps>((props, ref) => {
  const { isShowPopup, isLate, value, placeholder, dateFormat, errorMessage, isError } = props;
  const theme = useTheme();
  return (
    <Box>
      <Box
        ref={ref}
        sx={{
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          backgroundColor: 'transparent',
          padding: '2px 4px',
          borderRadius: '6px',
          transition: 'all 0.3s ease',
          userSelect: 'none',
          '&:hover': { backgroundColor: theme.palette.case.neutral.n75 },
          '&:active': { backgroundColor: theme.palette.case.neutral.n100 },
          ...(isShowPopup && {
            backgroundColor: theme.palette.case.neutral.n100,
            '&:hover': { backgroundColor: theme.palette.case.neutral.n100 },
            '&:active': { backgroundColor: theme.palette.case.neutral.n100 },
          }),
          ...(isError && {
            backgroundColor: theme.palette.case.red.r100,
            '&:hover': { backgroundColor: theme.palette.case.red.r100 },
            '&:active': { backgroundColor: theme.palette.case.red.r100 },
          }),
        }}
      >
        {value && (
          <Typography
            pt="2px"
            noWrap
            color={isLate ? theme.palette.case.red.r500 : theme.palette.case.neutral.n900}
            lineHeight="22px"
            variant="t14m"
          >
            {formatDateForView(value, dateFormat || 'h:mm A')}
          </Typography>
        )}
        {!value && placeholder && (
          <Typography
            noWrap
            pt="2px"
            color={theme.palette.case.aquamarine.a700}
            lineHeight={'22px'}
            variant="t14r"
          >
            {placeholder}
          </Typography>
        )}
      </Box>
      {errorMessage ? <InputError isShow={isError} message={errorMessage} /> : <></>}
    </Box>
  );
});

export default DatePickerIconButtonVariant;
